import { useStore } from '@contexts/store'
import { APIReturnType } from '@framework/model-types/APIReturnType'
import { UserProfile } from '@framework/model-types/UserProfile'
import { useApi } from '@utils/api'
import { API_ENDPOINTS } from '@utils/api-endpoints'

interface UserAPIReturnType extends APIReturnType {
  user: UserProfile
}

export const useSWRGetUser = (): UserAPIReturnType => {
  const { logout, user, storeData: shop } = useStore()
  const url = user?.person?._id
    ? `${API_ENDPOINTS.MANAGE_USER(shop?._id, user?.person?._id ?? '')}`
    : ''

  const { data, isError, mutate, isLoading } = useApi(url)
  if (
    isError?.response?.data?.success === false &&
    isError?.response?.data?.msg == 'Invalid token'
  ) {
    logout()
  }
  return {
    user: data?.data,
    isLoading,
    isError,
    mutate,
    key: url,
  }
}
